import Handlebars from 'handlebars';
import { HandlebarsOperator } from './types';

Handlebars.registerHelper('Math', function (v1: string, operator: HandlebarsOperator, v2: string):
    | number
    | null {
    switch (operator) {
        case '+':
            return parseInt(v1) + parseInt(v2);
        case '-':
            return parseInt(v1) - parseInt(v2);
        case '*':
            return Math.floor(parseFloat(v1) * parseFloat(v2));
        case '/':
            return Math.floor(parseFloat(v1) / parseFloat(v2));
        default:
            //throw new RangeError(`Unknown operator: ${operator}`);
            return null;
    }
});
